import { Layout } from '../components/Layout';
import { SMSOTPLoginForm } from '../components/SMSOTPLoginForm';

export const SMSOTPLogin = () => {
  return (
    <Layout title="SMS OTP Required">
      <SMSOTPLoginForm />
    </Layout>
  );
};
